export default "/images/vendor/flag-icon-css/flags/1x1/ve.svg?125ee9246eea1cb1b6626f2cb1f335af";